import env from '@beam-australia/react-env';
import useDatabase from '@pkg/database/useDatabase';
import useLogoutEvent from './useLogoutEvent';
import useStore from './useStore';

export default function useLogout() {
  const database = useDatabase();
  const me = useStore((state) => state.me);
  const triggerLogout = useLogoutEvent(me?.id);

  const fronteggLogout = `${env('FRONTEGG_BASE_URL')}/oauth/account/logout`;

  const completeLogout = async () => {
    // clear IndexedDB
    await database?.reset();
    // redirect to logout page
    window.location = fronteggLogout;

    return null;
  };

  return { triggerLogout, completeLogout };
}
